import QuotationList from '_modules/quotation/views/QuotationList.vue';
import QuotationPage from '_modules/quotation/views/QuotationPage.vue';

import QuotationCustomer from '_modules/quotation/components/QuotationStepCustomer.vue';
import QuotationProject from '_modules/quotation/components/QuotationStepProject.vue';
import QuotationService from '_modules/quotation/components/QuotationStepService.vue';
import QuotationDeal from '_modules/quotation/components/QuotationStepDeal.vue';
import QuotationInstallation from '_modules/quotation/components/QuotationStepInstallation.vue';
import QuotationForm from '_modules/quotation/components/QuotationStepForm.vue';
import QuotationFile from '_modules/quotation/components/QuotationStepFile.vue';
import QuotationApproved from '_modules/quotation/components/QuotationStepAprroved.vue';

import isAdminMiddleware from '@/router/middlewares/isAdminMiddleware';
import isCustomerMiddleware from '@/router/middlewares/isCustomerMiddleware';
import QuotationModelEdit from '_modules/quotation/views/QuotationModelEdit.vue';
import QuotationModelList from '_modules/quotation/views/QuotationModelList.vue';
import QuotationModelCreate from '_modules/quotation/views/QuotationModelCreate.vue';
import QuotationTemplateList from '_modules/quotation/views/QuotationTemplateList.vue';
import QuotationTemplatePage from '_modules/quotation/views/QuotationTemplatePage.vue';
// eslint-disable-next-line
const Quotation = r => require(['_modules/quotation/Root.vue'], r);

export default {
  path: 'orcamentos/',
  component: Quotation,
  name: 'admin-quotation',
  redirect: 'orcamentos/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-quotation-list',
      component: QuotationList,
    },
    {
      beforeEnter: isCustomerMiddleware,
      path: ':quotationId',
      component: QuotationPage,
      children: [
        {
          beforeEnter: isCustomerMiddleware,
          path: 'cliente',
          name: 'admin-quotation-customer',
          component: QuotationCustomer,
        },
        {
          beforeEnter: isCustomerMiddleware,
          path: 'obra',
          name: 'admin-quotation-project',
          component: QuotationProject,
        },
        {
          beforeEnter: isCustomerMiddleware,
          path: 'servico',
          name: 'admin-quotation-service',
          component: QuotationService,
        },
        {
          beforeEnter: isCustomerMiddleware,
          path: 'negociacao',
          name: 'admin-quotation-deal',
          component: QuotationDeal,
        },
        {
          beforeEnter: isCustomerMiddleware,
          path: 'instalacao',
          name: 'admin-quotation-installation',
          component: QuotationInstallation,
        },
        {
          beforeEnter: isCustomerMiddleware,
          path: 'orcamento',
          name: 'admin-quotation-edit',
          component: QuotationForm,
        },
        {
          beforeEnter: isCustomerMiddleware,
          path: 'fotos',
          name: 'admin-quotation-file',
          component: QuotationFile,
        },
        {
          beforeEnter: isCustomerMiddleware,
          path: 'final',
          name: 'admin-quotation-approved',
          component: QuotationApproved,
        },
      ],
    },
    {
      beforeEnter: isAdminMiddleware,
      path: 'modelo/lista/:page',
      name: 'admin-quotation-model-list',
      component: QuotationModelList,
    },
    {
      beforeEnter: isAdminMiddleware,
      path: 'modelo/novo',
      name: 'admin-quotation-model-new',
      component: QuotationModelCreate,
    },
    {
      beforeEnter: isAdminMiddleware,
      path: 'modelo/:quotationId',
      name: 'admin-quotation-model-edit',
      component: QuotationModelEdit,
    },
    {
      beforeEnter: isAdminMiddleware,
      path: 'templates/novo',
      name: 'admin-quotation-template-new',
      component: QuotationTemplatePage,
    },
    {
      beforeEnter: isAdminMiddleware,
      path: 'templates/:templateId',
      name: 'admin-quotation-template-edit',
      component: QuotationTemplatePage,
    },
    {
      beforeEnter: isAdminMiddleware,
      path: 'templates/lista/:page',
      name: 'admin-quotation-template-list',
      component: QuotationTemplateList,
    },
  ],
};
